module.exports = __webpack_public_path__ + "images/insights-ai-full-insights-ca93f94d.svg";